import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e65eb35"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Novo Widget", -1))
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = ["loading", "disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "ant-row" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_9 = {
  key: 0,
  class: "ant-row ss-div-linha"
}
const _hoisted_10 = { class: "ant-col ant-col-xs-23 ant-col-xl-23" }
const _hoisted_11 = { class: "ant-col ant-col-xs-1 ant-col-xl-1" }
const _hoisted_12 = {
  key: 0,
  class: "ant-row ss-div-linha"
}
const _hoisted_13 = { class: "ant-col ant-col-xs-23 ant-col-xl-23" }
const _hoisted_14 = { class: "ant-col ant-col-xs-1 ant-col-xl-1" }
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col ant-col-xs-12 ant-col-xl-6" }
const _hoisted_17 = { class: "ant-col ant-col-xs-12 ant-col-xl-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_selecionar_generico = _resolveComponent("selecionar-generico")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 600,
    centered: ""
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-primary",
            loading: _ctx.state.carregando,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirmar && _ctx.confirmar(...args))),
            disabled: _ctx.state.indexSelecionado === -1 || _ctx.state.carregando
          }, _hoisted_6, 8, _hoisted_4)
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_skeleton, {
            loading: _ctx.telaBase.carregando,
            paragraph: { rows: 5 }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_a_tabs, { defaultActiveKey: "1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_tab_pane, {
                        key: "1",
                        class: "ss-aba-lista",
                        tab: "VALORES"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.disponiveis, (widget, indexValor) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: widget.codigo
                            }, [
                              (widget.tipo === _ctx.ETipoWidget.Valor)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                      _createElementVNode("span", null, _toDisplayString(widget.titulo), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_11, [
                                      _createVNode(_component_a_checkbox, {
                                        checked: _ctx.state.indexSelecionado === indexValor,
                                        onClick: ($event: any) => (_ctx.selecionar(indexValor, _ctx.ETipoWidget.Valor))
                                      }, null, 8, ["checked", "onClick"])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "2",
                        class: "ss-aba-lista",
                        tab: "LISTAS"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.disponiveis, (widget, indexLista) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: widget.codigo
                            }, [
                              (widget.tipo === _ctx.ETipoWidget.Lista)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, [
                                      _createElementVNode("span", null, _toDisplayString(widget.titulo), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_14, [
                                      _createVNode(_component_a_checkbox, {
                                        checked: _ctx.state.indexSelecionado === indexLista,
                                        onClick: ($event: any) => (_ctx.selecionar(indexLista, _ctx.ETipoWidget.Lista))
                                      }, null, 8, ["checked", "onClick"])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "3",
                        class: "ss-aba-lista",
                        tab: "GRÁFICOS"
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "4",
                        class: "ss-aba-lista",
                        tab: "OUTROS"
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_a_form_item, {
                    label: "Tamanho do Widget",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_generico, {
                        itens: _ctx.state.tamanhos,
                        "limpar-selecao": false,
                        "mostrar-busca": false,
                        valor: _ctx.state.tamanho,
                        "onUpdate:valor": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.tamanho) = $event)),
                        onChange: _ctx.preencherLocalizacao
                      }, null, 8, ["itens", "valor", "onChange"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_a_form_item, {
                    label: "Limite de Registros",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_generico, {
                        itens: _ctx.state.limites,
                        "limpar-selecao": false,
                        "mostrar-busca": false,
                        valor: _ctx.state.limite,
                        "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.limite) = $event))
                      }, null, 8, ["itens", "valor"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}